import Styled from 'styled-components'

import theme from '../theme'


const HideDesktop = Styled.div`
  @media (min-width: ${theme.breakpoint}px) {
    display: none;
  }
`


export default HideDesktop
